module.controller('giftCardCtrl', ['$scope', '$state', 'cacheService','baseURI', '$http', 'Transform', '$window', '$timeout', '$sce', 'Session', 'OVERLAY', '$rootScope', '$stateParams', '$location', function($scope, $state, cacheService,baseURI, $http, Transform, $window, $timeout, $sce, Session, OVERLAY, $rootScope, $stateParams, $location){
  var giftCardOrderUrl;

  $scope.isOnDashboard = $location.path().indexOf('/member') !== -1;

  if($scope.isOnDashboard){
    giftCardOrderUrl = baseURI + 'giftcard/order';
  } else {
    giftCardOrderUrl = baseURI + 'gift-card/order';
  }

  $http.get(baseURI + 'card/physical?_key=' + encodeURIComponent($scope.brand.api_key))
    .then(function(resp){
      $scope.supportsPhysical = resp.data.Data.PhysicalProgram;
    })
    .catch(function(err){
    });

  $scope.currentDate = Date.now();

  $scope.alert = {};
  $scope.alertError = {};
  $scope.parent = {};
  $scope.formData = {};
  $scope.giftCardForm = {};
  $scope.giftCardForm.amount = '25.00';
  $scope.giftCardForm.selectedDelivery = 0;
  $scope.formData.selectedPayment = 2;
  $scope.formData.ccinfo = {};
  $scope.parent.overlayLoading = false;
  $scope.loading = false;
  $scope.totalAmount = 0;
  $scope.totalFeeAmount = 0;
  $scope.separatedFees = $scope.brand.giftCardSeparatedFees || {"fee": 0};

  $http.get(baseURI + 'card_order/fee?_key=' + encodeURIComponent($scope.brand.api_key) + '&ProgramType=Gift-Virtual')
    .then(function(resp){
      $scope.fee = resp.data.Data.Fee;
      //check for cached cards in cart
      getShoppingCart();
    })
    .catch(function(err){
      $scope.fee = 4.95; // default to 4.95 if card_order/fee fails
      //check for cached cards in cart
      getShoppingCart();
    });


  if($scope.isOnDashboard){
    // Widget specific configs
    $scope.overlay = OVERLAY['member.home.send/gift'];

    $scope.submitted = false;
    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to process the transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
    $scope.limits = Session.getLimits()['CRD-TRN-OUT'];
    $scope.amountValid = false;
    $scope.amountMessage = null;
    $scope.balance = $rootScope.balance || Session.getBalance();
    $scope.maxCardValue = 1000;
    $scope.formData.selectedPayment = 0;

    // get profile email
    getProfileEmail();

    // get CH banks
    // todo: check bank status'
    //getBanks();
  } else {
    $scope.maxCardValue = 200;
  }

  // kount url config
  var dirtySessionId = uuid.v1();
  var akimboUrl = baseURI.replace('api/v2/', '');

  $scope.sessionId = dirtySessionId.replace(/-/g, '');
  $scope.kountUrl = $sce.trustAsResourceUrl(akimboUrl + 'k/logo.htm?m=157500&s=' + $scope.sessionId);

  // update the active tab view
  $scope.selectTab = function(tab, selected){
    if(tab == 'selectedDelivery'){
      $scope.giftCardForm[tab] = selected;
    } else {
      $scope.formData[tab] = selected;
      updateTotalAmount();
    }
  };

  // print receipt success page
  $scope.printReceipt = function(){
    window.print();
  };

  // controls for updating amount
  $scope.amountControl = function(addToAmount){
    $scope.giftCardForm.amount = Number($scope.giftCardForm.amount);
    if($scope.giftCardForm.amount >= 10 || addToAmount > 0) {
      $scope.giftCardForm.amount += addToAmount;
    }
    formatAmount();
  };

  // validate form and goto next step
  $scope.attemptSubmission = function(giftCardForm, next){

    f = giftCardForm.recipientEmail;
    if (f && f.$viewValue && f.$viewValue.indexOf("@") === -1 && f.$viewValue.length !== 10) {
      $scope.invalidPhone = true;
      $scope.submitted = true;
      $scope.alert.errorShown = true;
      return;
    }

    if(giftCardForm.$valid && ($scope.giftCardForm.amount >= 5 && $scope.giftCardForm.amount <= $scope.maxCardValue)){
      showLoading(true);
      createAnalyticsEvent(next);
      $window.scrollTo(0,0);
      $scope.submitted = false;
      $scope.alert.errorShown = false;
      $state.go(next).then(function(){
        showLoading(false);
      });
    } else {
      $scope.submitted = true;
      $scope.alert.errorShown = true;
    }
  };

  // submission on last step
  $scope.processForm = function(giftCardForm){
    if(giftCardForm.$valid && validatePayment()){
      $scope.submitted = false;
      $scope.alert.errorShown = false;
      submitCardOrder();
    } else {
      $scope.alert.errorShown = true;
      $scope.submitted = true;
    }
  };

  // cvv information
  $scope.alertCvv = function(){
    alert('For Visa, Mastercard or Discover, your CVV number is a 3-digit code typically printed on the back of your card. For Amex, it is a 4-digit code typically printed on the front above your card number.');
  };

  // Get the banks
  function getBanks (){
    $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
      $scope.banks = resp.data.Data || [];
      $scope.formData.Bank = $scope.banks[0];
    }).catch(function(){
      $scope.banks = [];
    });
  }

  // create analytics event for each step
  var createAnalyticsEvent = function(next){
    switch(next){
    case 'root.giftCard.step2':
      break;
    case 'member.home.send/gift.step3':
      updateShoppingCart($scope.giftCardForm);
      break;
    case 'root.giftCard.step3':
      updateShoppingCart($scope.giftCardForm);
      break;
    case 'root.giftCard.success':
      break;
    }
  };

  var formatAmount = function(){
    var amount = String($scope.giftCardForm.amount);
    amount = amount.split('.');
    if(amount.length == 1){
      $scope.giftCardForm.amount += '.00';
    }
  };

  var validatePayment = function(){
    updateTotalAmount();
    if($scope.formData.selectedPayment == 2){
      switch ($scope.formData.cctype){
      case 'Amex':
        return ($scope.formData.cardNumber.length == 15);
      case 'MasterCard':
      case 'Visa':
      case 'Discover':
        return ($scope.formData.cardNumber.length == 16);
      }
    } else if ($scope.formData.selectedPayment === 0) {
      return ($scope.totalAmount < $rootScope.balance);
    } else {
      return (($scope.totalAmount + $scope.totalFeeAmount) < $rootScope.balance);
    }
  };

  // final submission for gift cards
  var submitCardOrder = function(){
    showLoading(true);
    $window.scrollTo(0,0);
    var formData = $scope.formData;

    var request = {
      _key: $scope.brand.api_key,
      SessionId: $scope.sessionId
    };

    switch($scope.formData.selectedPayment){
    case 0:
      request.PaymentType = 'balance';
      request.SenderEmail = $scope.formData.profileEmail;
      break;
    case 1:
      request.PaymentType = 'bank';
      break;
    case 2:
      request.PaymentType = 'credit card';
      request.CardType = getCardType(formData.cctype);
      request.CardNumber = formData.cardNumber;
      request.ExpDate = formatExpDate(formData.expDate);
      request.CVV = formData.cvv;
      request.BillingFirstName = formData.billingFirstName;
      request.BillingLastName = formData.billingLastName;
      request.BillingAddress = formData.billingAddress1;
      request.BillingAddress2 = formData.billingAddress2 || '';
      request.BillingCity = formData.billingCity;
      request.BillingState = formData.billingState;
      request.BillingZip = formData.billingZip;
      request.SenderEmail = formData.billingEmail;
      break;
    }

    // get the cards and append them to the request
    request.Cards = JSON.stringify(getCardsInCart());

    $http({
      method: 'POST',
      url: giftCardOrderUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      if(data.Success){
        // reset cached cart
        Session.setShoppingCart([]);

        // ui updates
        showLoading(false);
        $scope.currentDate = Date.now();
        $window.scrollTo(0,0);

        // send analytics
        createAnalyticsEvent('root.giftCard.success');
        sendGAConversion();

        // show success
        if($scope.isOnDashboard){
          cacheService.clear('transfer');
          $state.go('member.home.send/gift.success');
        } else {
          var showVideo = false;
          if ($scope.brand.giftCardReceiptVideo && formData.cctype == 'MasterCard') {
            showVideo = true;
          }
          $state.go('root.giftCard.success', {showVideo: showVideo});
        }
      } else {
        showLoading(false);
        processPaymentError();
      }
    }).catch(function(err){
      showLoading(false);
      processPaymentError();
    });
  };


  var processPaymentError = function(){
    $window.scrollTo(0,0);
    $scope.alertError.show = true;
    $scope.alertError.message = 'Oops, we were unable to process payment, please verify the billing information is correct and try again.';
  };

  var getCardType = function(cctype){
    switch(cctype){
    case 'MasterCard':
      return 'MSTR';
    case 'Visa':
      return 'VISA';
    case 'Amex':
      return 'AMEX';
    case 'Discover':
      return 'DISC';
    default:
      return undefined;
    }
  };

  var formatExpDate = function(date){
    var formattedExpDate =  date.split('/');
    if(formattedExpDate[1].length == 4){
      return formattedExpDate[0] + '/' + formattedExpDate[1];
    } else {
      return formattedExpDate[0] + '/20' + formattedExpDate[1];
    }
  };

  var sendGAConversion = function(){
    try {
      $window.google_trackConversion({
        google_conversion_id: 959574293,
        google_conversion_language: "en",
        google_conversion_format: "3",
        google_conversion_color: "ffffff",
        google_conversion_label: "0ZzOCMPngWIQleLHyQM",
        google_conversion_value: $scope.totalAmount,
        google_conversion_currency: "USD",
        google_remarketing_only: false
      });
    } catch(err) {
    }
  };

  function getProfileEmail(){
    $http.get(baseURI + 'cardholder/profile').then(function(resp){
      $scope.formData.profileEmail = resp.data.data.Data.Email;
    });
  }

  var showLoading = function(show){
    if($scope.isOnDashboard){
      $scope.loading = show;
    } else {
      $scope.parent.overlayLoading = show;
    }
  };

  // shopping cart logic
  var getCardsInCart = function(){
    var formattedCards = [];

    for(var c in $scope.shoppingCart){
      var card = {
        Amount: Number($scope.shoppingCart[c].amount),
        Message: $scope.shoppingCart[c].message,
        FromName: $scope.shoppingCart[c].from,
        RecipientFirstName: $scope.shoppingCart[c].firstName,
        RecipientLastName: $scope.shoppingCart[c].lastName
      };
      if($scope.shoppingCart[c].selectedDelivery === 0){
        card.CardType = 'virtual';
        card.RecipientEmail = $scope.shoppingCart[c].recipientEmail;
      } else {
        card.CardType = 'plastic';
        card.ShippingFirstName = $scope.shoppingCart[c].shippingFirstName;
        card.ShippingLastName = $scope.shoppingCart[c].shippingLastName;
        card.ShippingAddress = $scope.shoppingCart[c].shippingAddress1;
        card.ShippingAddress2 = $scope.shoppingCart[c].shippingAddress2 || '';
        card.ShippingCity = $scope.shoppingCart[c].shippingCity;
        card.ShippingState = $scope.shoppingCart[c].shippingState;
        card.ShippingZip = $scope.shoppingCart[c].shippingZip;
      }
      formattedCards.push(card);
    }

    return formattedCards;
  };


  var updateShoppingCart = function(card){
    if(!card.createdAt){
      addToShoppingCart(card);
    } else {
      // update this card in the shopping cart
      for(var gift in $scope.shoppingCart){
        if($scope.shoppingCart[gift].createdAt == card.createdAt){
          setDeliveryType(card);
          $scope.shoppingCart[gift] = card;
          updateTotalAmount();
          refreshGiftCardForm();
        }
      }
    }
  };

  var setDeliveryType = function(card){
    if (card.selectedDelivery == 1) {
      card.deliveryType = 'mail';
    } else if (card.recipientEmail.indexOf("@") === -1) {
      card.deliveryType = 'phone';
    } else {
      card.deliveryType = 'email';
    }
  };

  var addToShoppingCart = function(newCard){
    newCard.createdAt = Date.now();
    setDeliveryType(newCard);
    $scope.shoppingCart.push(newCard);
    refreshGiftCardForm();
    updateTotalAmount();
  };

  var refreshGiftCardForm = function(){
    $scope.giftCardForm = {};
    $scope.giftCardForm.amount = '25.00';
    $scope.giftCardForm.selectedDelivery = 0;
  };

  // called on shopping cart changes
  function updateTotalAmount(){
    var total = 0;
    var canSendFromBank = true;

    for(var c in $scope.shoppingCart){
      total += Number($scope.shoppingCart[c].amount);
      if($scope.shoppingCart[c].selectedDelivery != '1'){
        canSendFromBank = false;
      }
    }

    $scope.canSendFromBank = canSendFromBank;

    // update total card value
    $scope.totalAmount = total;

    // update total fee amount
    if ($scope.isOnDashboard && $scope.formData.selectedPayment === 0) {
      $scope.totalFeeAmount = 0;
    } else {
      $scope.totalFeeAmount = $scope.shoppingCart.length * $scope.fee;
    }

    // update cached cart
    Session.setShoppingCart($scope.shoppingCart);
  }

  // get shopping cart cache
  function getShoppingCart(){
    $scope.shoppingCart = Session.getShoppingCart() || [];

    if($scope.shoppingCart.length > 0){
      updateTotalAmount();
      if($scope.isOnDashboard){
        $state.go('member.home.send/gift.step3');
      } else {
        $state.go('root.giftCard.step3');
      }
    }
  }

  $scope.removeCard = function(createdAt){
    if($scope.shoppingCart.length > 1){
      for(var gift in $scope.shoppingCart){
        if($scope.shoppingCart[gift].createdAt == createdAt){
          $scope.shoppingCart.splice(gift, 1);
          break;
        }
      }
    } else {
      $scope.shoppingCart = [];
      if($scope.isOnDashboard){
        $state.go('member.home.send/gift.step1');
      } else {
        $state.go('root.giftCard.step1');
      }
    }
    updateTotalAmount();
  };

  $scope.editCard = function(createdAt){
    for(var gift in $scope.shoppingCart){
      if($scope.shoppingCart[gift].createdAt == createdAt){
        $scope.giftCardForm = $scope.shoppingCart[gift];
        break;
      }
    }
    $scope.submitted = false;
    $scope.alert.errorShown = false;
    if($scope.isOnDashboard){
      $state.go('member.home.send/gift.step1');
    } else {
      $state.go('root.giftCard.step1');
    }
  };

  $scope.createAnother = function(){
    $scope.submitted = false;
    $scope.alert.errorShown = false;
    if($scope.isOnDashboard){
      $state.go('member.home.send/gift.step1');
    } else {
      $state.go('root.giftCard.step1');
    }
  };


}]);
